import { UnitTypes } from 'src/Libs/types'
import { LabelConfig } from '../chart-kit'
import { CostSavingChartExportData } from './types'
import { CountryCode, CountryCodes } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { isFlowTheme } from '../utils'

export const MASTER_IS_OFFLINE_KEY = 'systemSettings.dynamic-prices.master-offline'
export const COUNTRY_NOT_AVAILABLE_KEY = 'systemSettings.dynamic-prices.country-not-available'
export const DPP_AVAILABLE_COUNTRY_CODES: CountryCode[] = isFlowTheme
  ? [CountryCodes.GERMANY, CountryCodes.NETHERLANDS]
  : [CountryCodes.GERMANY, CountryCodes.NETHERLANDS, CountryCodes.AUSTRIA]

export const dayViewLabelConfig: LabelConfig<Partial<CostSavingChartExportData>> = {
  time: { translationKey: 'dynamic-power-prices.cost-saving-chart.csv-ts' },
  consumptionPrice: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.consumption-price',
    unit: UnitTypes.cents,
  },
}

export const emsLabelConfig: LabelConfig<Partial<CostSavingChartExportData>> = {
  time: { translationKey: 'dynamic-power-prices.cost-saving-chart.csv-ts' },
  consumptionPrice: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.consumption-price',
    unit: UnitTypes.cents,
  },
  batteryMode: { translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.ems-mode' },
}

export const labelConfig: LabelConfig<Partial<CostSavingChartExportData>> = {
  time: { translationKey: 'systemDataHandler.chartHeader.ts' },
  consumptionPrice: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.consumption-price',
    unit: UnitTypes.cents,
  },
  threeSixtyBatteryProducedEnergy: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.three-sixty-savings-hps',
    unit: UnitTypes.kiloWattHour,
  },
  threeSixtyBatterySavings: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.three-sixty-produced-energy-hps',
    unit: UnitTypes.cents,
  },
  threeSixtyWallboxProducedEnergy: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.three-sixty-savings-wallbox',
    unit: UnitTypes.kiloWattHour,
  },
  threeSixtyWallboxSavings: {
    translationKey: 'dynamic-power-prices.cost-saving-chart.csv-export.three-sixty-produced-energy-wallbox',
    unit: UnitTypes.cents,
  },
}
